import commonText from './configs/common/commonText'
import { CONTENTS_NXT_CONSTANTS } from './configs/contentsNxt/constants'
import contentsNxtText from './configs/contentsNxt/contentsText'
import { LIABILITY_CONSTANTS } from './configs/shared/constants'
import * as schemaUtils from './configs/shared/schemaUtils'
import * as schema from './insurance/schemas'
import * as stepContentUtils from './insurance/utils/stepContentUtils'
import * as stepContentFormUtils from './renderer/utils/forms'

export type { ContentsNeoStepConfigParams } from './configs/contents/types'

export * from './configs'
export * from './configs/de/incomeProtection'
export * from './configs/de/privateHealth'
export * from './configs/de/publicHealth'
export * from './configs/de/legalRoland'
export * from './configs/de/privatePension'
export * from './configs/de/childSaving'
export * from './configs/de/termLife'
export * from './configs/de/dental'
export * from './core/types/stepContentTypes'
export * from './core/types/CustomComponent'
export * from './core/types/stepTypes'
export * from './core/i18n/types'
export type { ValidationParameters } from './core/types/validationTypes'
export * from './core/types/dispatchedHookTypes'
export {
  generateGetFlowValueFunctions,
  getTransientPath,
  getProductParamPath,
  getProductHelperPath,
} from './insurance/utils'
export * from './configs/types'
export { productBaseProductMapping } from './insurance/types/products/dependencies'
export type {
  Pricing_LiabilityPremiumBasicNeodigitalDe,
  Pricing_LegalBasis3BasicRolandDe,
  Pricing_UnifiedLegalBasis3BasicRolandDe,
  Pricing_UnifiedLegalComfort3BasicRolandDe,
  Pricing_ContentsPremiumBasicNeodigitalDe,
  Pricing_ContentsComfortBasicNeodigitalDe,
  Pricing_ContentsPremiumBikeTheftNeodigitalDe,
  Pricing_ContentsComfortBikeTheftNeodigitalDe,
  Pricing_BikeTheftPremiumBasicNeodigitalDe,
  Pricing_UnifiedBikeTheftPremiumBasicNeodigitalDe,
  Pricing_DogLiabilityBasicDe,
  Pricing_DentalOttonova75PlusDe,
  Config_LiabilityDronesNeodigitalDe,
  Config_DogLiabilityBasicDe,
  Config_DogLiabilityPremiumDe,
  Config_BikeTheftPremiumBasicNeodigitalDe,
  Config_UnifiedBikeTheftPremiumBasicNeodigitalDe,
  Config_LiabilityV1GetsafeDe,
  Pricing_LiabilityV1GetsafeDe,
  Config_DogLiabilityV1GetsafeDe,
  Pricing_DogLiabilityV1GetsafeDe,
  Pricing_ContentsV1GetsafeDe,
  Config_ContentsV1GetsafeDe,
  Config_PetHealthV1GetsafeDe,
  Config_PetHealthV1LukoToGetsafeDe,
  Config_ContentsV1LukoToGetsafeDe,
} from './insurance/types/products/de'
export type { Config_HouseholdV1GetsafeAt } from './insurance/types/products/at'

export type {
  BaseProductKey,
  ExtensionProductKey,
  ProductKey,
  ProductGroupKey,
} from './insurance/types/productKeys'
export { baseProdKeys } from './insurance/types/productKeys'
export * from './insurance/types/subFlowTypes'
export type {
  ProductGeneration,
  CoveragePlan,
  ProductExtension,
  ProductDocument,
  CmsIcon,
  CoverageTooltip,
  CoverageBenefit,
  CoverageInformationItem,
  CoverageBreakdownItem,
  CoveragePlanHeader,
  CoverageBreakdownDetails,
  ProductContentSection,
  ProductContentMainGroup,
  ProductContentSubGroup,
  InfoItem,
  ConfigurationParameterMap,
  ProductImageAsset,
  ProductIcon,
} from './insurance/types/productGenerationTypes'
export type { SplitName } from './insurance/types/splitNameTypes'
export type { StepName } from './insurance/types/stepNameTypes'
export type {
  PriceConfiguration,
  ProductConfiguration,
  Products,
  ProductConfigurationKey,
} from './insurance/types/products'
export {
  MINIMUM_CUSTOMER_AGE,
  MAXIMUM_CUSTOMER_AGE,
  TARIFF_LINE_OPTIONS,
  FAILURE_STEP_NAME,
} from './insurance/constants'

export { default as commonTextOld } from './configs/common/commonText'
export const translationsOld = {
  commonText,
  contentsNxtText,
}
export { translations } from '@flows/configs/translations'
export const CONSTANTS = {
  CONTENTS_NXT: CONTENTS_NXT_CONSTANTS,
  LIABILITY_NEO: LIABILITY_CONSTANTS,
}
export { stepContentUtils, stepContentFormUtils }
export { default as stepContentRenderer } from './renderer'
export type { StepContentRendererProps, ComponentMap } from './renderer/types'

export { schema, schemaUtils }

export { failureReasonAnalytics } from '@flows/insurance/analytics'
export type {
  FailureReason,
  FailureReasonContext,
  GetFailureReason,
} from '@flows/insurance/analytics/types'

export { initFlowsI18n } from '@flows/core/i18n'
export * from '@flows/configs/shared/flowConfiguration'
export type { GetLocationStepContent } from '@flows/configs/common/locationUtils'
export { getLocationStepContent } from '@flows/configs/common/locationUtils'
export { MARKETING_CONSENT_FORM_KEY_TO_MARKET_MAP } from '@flows/configs/common/steps/email_and_name'
